import React from "react";
const CloseIcon = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fill: "#003A56",
    fillRule: "evenodd",
    d: "M22 4.222L14.222 12 22 19.778 19.778 22 12 14.222 4.222 22 2 19.778 9.778 12 2 4.222 4.222 2 12 9.778 19.778 2z"
  }));
};
export default CloseIcon;